/** Haversine distance in miles between two lat/lng points. */
export function distanceMiles(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const R = 3959; // Earth radius in miles
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export const DEFAULT_DELIVERY_RADIUS_MILES = 5;

export function boutiqueDeliversTo(
  boutiqueLat: number,
  boutiqueLng: number,
  deliveryRadiusMiles: number,
  shopperLat: number,
  shopperLng: number
): boolean {
  const dist = distanceMiles(shopperLat, shopperLng, boutiqueLat, boutiqueLng);
  return dist <= (deliveryRadiusMiles || DEFAULT_DELIVERY_RADIUS_MILES);
}

export function formatMiles(miles: number): string {
  if (miles < 0.1) return '< 0.1 mi';
  if (miles < 10) return `${miles.toFixed(1)} mi`;
  return `${Math.round(miles)} mi`;
}
